export const HAS_COMPLETE_ACTION = 'HAS_COMPLETE_ACTION';
export const RESET_COMPLETE_ACTIONS = 'RESET_COMPLETE_ACTIONS';
